import React, { useState, useEffect } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && user && user.role === "admin") navigate("/admin");
  }, [user, loading, navigate]);

  if (loading) return <div className="px-6 py-24" data-testid="login-loading">Checking…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) setError(res.error || "Login failed");
    else navigate("/admin");
  };

  return (
    <div className="px-6 md:px-12 lg:px-16 py-16 md:py-24 max-w-md mx-auto" data-testid="login-page">
      <Link to="/" className="upr-link-underline text-sm">← Back to site</Link>
      <div className="upr-eyebrow mt-8 mb-4">Admin</div>
      <h1 className="font-heading font-black tracking-tighter leading-[0.9] text-5xl md:text-6xl" style={{ letterSpacing: "-0.035em" }}>
        Sign in.
      </h1>
      <form onSubmit={onSubmit} className="mt-10 space-y-5" data-testid="login-form">
        <div>
          <label className="upr-eyebrow block mb-2" htmlFor="email">Email</label>
          <input
            id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full p-3 bg-transparent border focus:outline-none focus:border-[color:var(--upr-primary)]"
            style={{ borderColor: "var(--upr-border)" }}
          />
        </div>
        <div>
          <label className="upr-eyebrow block mb-2" htmlFor="password">Password</label>
          <input
            id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full p-3 bg-transparent border focus:outline-none focus:border-[color:var(--upr-primary)]"
            style={{ borderColor: "var(--upr-border)" }}
          />
        </div>
        {error && (
          <div className="text-sm p-3 border" data-testid="login-error" style={{ borderColor: "var(--upr-primary)", color: "var(--upr-primary)" }}>
            {error}
          </div>
        )}
        <button type="submit" disabled={busy} className="upr-btn w-full" data-testid="login-submit">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
